"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _reactSimpleCodeEditor = _interopRequireDefault(require("react-simple-code-editor"));
var _prismCore = require("prismjs/components/prism-core");
require("prismjs/components/prism-clike");
require("prismjs/components/prism-javascript");
require("prismjs/components/prism-json");
require("prismjs/components/prism-graphql");
require("./styles.scss");
var _cccisdConfirm = _interopRequireDefault(require("cccisd-confirm"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _gui = require("../../../../reducers/gui.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Editor = /*#__PURE__*/function (_React$Component) {
  function Editor() {
    var _this;
    _classCallCheck(this, Editor);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Editor, [].concat(args));
    _defineProperty(_this, "state", {
      editorData: '',
      mode: _this.props.mode
    });
    _defineProperty(_this, "componentDidMount", function () {
      var _this$props = _this.props,
        files = _this$props.files,
        filename = _this$props.filename,
        inputString = _this$props.inputString;
      if (filename) {
        if (filename.match(/\.graphql$/)) {
          _this.setState({
            mode: 'graphql'
          });
        }
        var file = files[filename];
        var contents = file ? file.contents : '';
        _this.setState({
          editorData: contents
        });
      } else {
        _this.setState({
          editorData: inputString
        });
      }
    });
    _defineProperty(_this, "editorRefresh", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var _this$props2, files, filename, inputString, contents;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this$props2 = _this.props, files = _this$props2.files, filename = _this$props2.filename, inputString = _this$props2.inputString;
            if (filename) {
              _context.n = 1;
              break;
            }
            _this.setState({
              editorData: inputString
            });
            return _context.a(2);
          case 1:
            contents = files[filename] ? files[filename].contents : '';
            _this.setState({
              editorData: contents
            });
          case 2:
            return _context.a(2);
        }
      }, _callee);
    })));
    _defineProperty(_this, "editorSave", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(event) {
        var overwriteAllModified,
          _this$state,
          mode,
          editorData,
          _this$props3,
          files,
          filename,
          jsonAsObj,
          filesToWrite,
          response,
          _args2 = arguments,
          _t,
          _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              overwriteAllModified = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : false;
              _this$state = _this.state, mode = _this$state.mode, editorData = _this$state.editorData;
              _this$props3 = _this.props, files = _this$props3.files, filename = _this$props3.filename;
              if (filename) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              jsonAsObj = editorData;
              if (!(mode === 'json' && filename)) {
                _context2.n = 6;
                break;
              }
              _context2.p = 2;
              _context2.n = 3;
              return JSON.parse(editorData);
            case 3:
              jsonAsObj = _context2.v;
              _context2.n = 5;
              break;
            case 4:
              _context2.p = 4;
              _t = _context2.v;
              (0, _cccisdNotification["default"])({
                duration: 2250,
                message: 'JSON did not parse, please correct.',
                type: 'danger'
              });
              return _context2.a(2);
            case 5:
              _this.setState({
                editorData: JSON.stringify(jsonAsObj, null, 4)
              });
            case 6:
              _this.setState({
                disableWrite: true
              });
              filesToWrite = [{
                filename: filename,
                contents: mode === 'json' ? JSON.stringify(jsonAsObj, null, 4) : editorData,
                modified: files[filename] ? files[filename].modified : ''
              }];
              _context2.n = 7;
              return _this.props.changeLocalFiles(filesToWrite);
            case 7:
              _context2.n = 8;
              return _this.props.writeFiles(filesToWrite.map(function (fileData) {
                return fileData.filename;
              }), overwriteAllModified);
            case 8:
              response = _context2.v;
              if (!(response.status !== 200)) {
                _context2.n = 9;
                break;
              }
              (0, _cccisdNotification["default"])({
                duration: 2250,
                message: 'Encountered error while writing file',
                type: 'danger'
              });
              _this.setState({
                disableWrite: false
              });
              _context2.n = 13;
              break;
            case 9:
              if (!(response.data.status === 'success')) {
                _context2.n = 10;
                break;
              }
              _this.setState({
                disableWrite: false
              });
              _context2.n = 13;
              break;
            case 10:
              _context2.p = 10;
              _context2.n = 11;
              return (0, _cccisdConfirm["default"])({
                message: "Warning: This file has been modified on the filesystem while you've been working.",
                description: "Would you like to overwrite the file `".concat(filename, "`?")
              });
            case 11:
              _this.editorSave(null, true);
              _context2.n = 13;
              break;
            case 12:
              _context2.p = 12;
              _t2 = _context2.v;
              _this.setState({
                disableWrite: false
              });
            case 13:
              return _context2.a(2);
          }
        }, _callee2, null, [[10, 12], [2, 4]]);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "handleOnChange", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(inputJson) {
        var onChange;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              onChange = _this.props.onChange;
              onChange(inputJson);
              if (_this.state.editorData !== inputJson) {
                _this.setState({
                  editorData: inputJson
                });
              }
            case 1:
              return _context3.a(2);
          }
        }, _callee3);
      }));
      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    }());
    return _this;
  }
  _inherits(Editor, _React$Component);
  return _createClass(Editor, [{
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
        disableWrite = _this$state2.disableWrite,
        mode = _this$state2.mode,
        editorData = _this$state2.editorData;
      var filename = this.props.filename;
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "language-".concat(mode)
      }, /*#__PURE__*/_react["default"].createElement(_reactSimpleCodeEditor["default"], {
        highlight: function highlight(code) {
          return (0, _prismCore.highlight)(code, _prismCore.languages[mode]);
        },
        onValueChange: this.handleOnChange,
        padding: 14,
        style: {
          background: '#f5f2f0',
          borderRadius: '4px',
          boxSizing: 'border-box',
          caretColor: '#333',
          fontFamily: 'Menlo, Courier, "Courier New", monospace',
          fontSize: 14,
          minHeight: '25em'
        },
        tabSize: 4,
        value: editorData
      })), filename && /*#__PURE__*/_react["default"].createElement("div", {
        className: "mt-3 mb-3 d-flex justify-content-end gap-2"
      }, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-secondary btn-primary".concat(disableWrite ? ' disabled' : ''),
        onClick: this.editorSave
      }, "Save"), /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-secondary",
        onClick: this.editorRefresh
      }, "Refresh")));
    }
  }]);
}(_react["default"].Component);
_defineProperty(Editor, "propTypes", {
  /** The string to edit. Not used if 'filename' prop provided. */
  inputString: _propTypes["default"].string,
  /** Method to save file in redux */
  changeLocalFiles: _propTypes["default"].func,
  /** The files in redux */
  files: _propTypes["default"].object,
  /** The filename to edit (pulled from redux) */
  filename: _propTypes["default"].string,
  /** The mode that should be used when editing the file (defaults to 'json') */
  mode: _propTypes["default"].string,
  /** Method called with editor data as argument on change */
  onChange: _propTypes["default"].func,
  /** Method to write files to back-end */
  writeFiles: _propTypes["default"].func
});
_defineProperty(Editor, "defaultProps", {
  inputString: '',
  filename: '',
  mode: 'json',
  onChange: function onChange(data) {}
});
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    files: state.appdefs.gui.files
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, {
  changeLocalFiles: _gui.changeLocalFiles,
  writeFiles: _gui.writeFiles
})(Editor);